<template>
	<div class="mia-Feature">
		<div class="mia-featureContent row">
			<div class="mia-featureImage">
				<inline-svg :src="featureImage" />
			</div>
			<div class="mia-featureDescription col-xs-50">
				<h3 v-tr="`landingpage_rewardandsocial_${featureKey}_header`" class="responsive-h3" />
				<p v-tr="`landingpage_rewardandsocial_${featureKey}_desc`" class="responsive-paragraph" />
			</div>
		</div>
	</div>
</template>
<script lang="ts">
import { Component, Prop, Vue, toNative } from "vue-facing-decorator";
import EarnRewardsImage from "@theme/features/earnRewards.svg";
import NewspaperImage from "@theme/features/newspaper.svg";
import ShopImage from "@theme/features/shop.svg";
import CommunityImage from "@theme/features/community.svg";
import InlineSvg from "vue-inline-svg";

@Component({
	components: { InlineSvg },
})
export class Feature extends Vue {
	@Prop({ required: true, type: String }) public featureKey!: 'earnRewards' | 'newspaper' | 'shop' | 'community';

	get featureImage() {
		return {
			earnRewards: EarnRewardsImage,
			newspaper: NewspaperImage,
			shop: ShopImage,
			community: CommunityImage,
		}[this.featureKey];
	}
}

export default toNative(Feature);
</script>
<style lang="scss">
.mia-Feature {
	box-shadow: theme.$mia-shadow-box;
	margin: calc(#{theme.$mia-grid-gutter-width} / 2);
	padding: theme.$mia-padding-panel theme.$mia-padding-panel-large;
	border-radius: theme.$mia-border-radius-big;

	.mia-featureContent {
		display: flex;
		align-items: center;
		height: 100%;
	}

	.mia-featureContent .mia-featureImage {
		padding: theme.$mia-padding-panel theme.$mia-padding-panel-large;

		svg {
			min-width: theme.$mia-icon-size-xxl;
			height: 100%;
		}
	}	

	@media (max-width: theme.$screen-sm-max) {
		.mia-featureContent .mia-featureImage svg {
			height: 50%;
			min-width: theme.$mia-icon-size-huge;
		}
	}

	@media (max-width: theme.$screen-xs-max) {
		.mia-featureContent .mia-featureImage {
			svg {
				min-width: theme.$mia-icon-size-huge;
			}
		}
	}
}
</style>
